import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import SavedTabs from "./SavedTabs";
import SavedSummary from "./SavedSummary";
import SavedErrorDetails from "./SavedErrorDetails";
import SavedRuleCatalogue from "./SavedRuleCatalogue";
import { Box } from "@mui/material";

const SavedDataProduct = () => {
  const { dashboardId } = useParams();
  const [searchParams] = useSearchParams();

  const productId = searchParams.get("product"); // 🔥 Extract Product ID

  const tabFromUrl = searchParams.get("tab") || "Summary";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters || {});
  };

  return (
    <Box sx={{ padding: 0 }}>
      <div className="dashboard-dashboard poppins-regular">
        <SavedTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          hideActions={true}
        />

        <div
          className="tab-content-tab"
          style={{ background: "#F7F7F7", padding: "28px" }}
        >
          {activeTab === "Summary" && (
            <SavedSummary
              dashboardId={dashboardId}
              productId={productId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}

          {activeTab === "Error Details" && (
            <SavedErrorDetails
              dashboardId={dashboardId}
              productId={productId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}

          {activeTab === "Rule Catalogue" && (
            <SavedRuleCatalogue
              dashboardId={dashboardId}
              productId={productId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}
        </div>
      </div>
    </Box>
  );
};

export default SavedDataProduct;
